const map = {
	"./avatar-1.png": 42945,
	"./avatar-2.png": 1866,
	"./avatar-3.png": 33779,
	"./avatar-4.png": 36380,
	"./avatar-5.png": 72293,
	"./avatar-6.png": 44462,
	"./avatar-7.png": 43959,
	"./avatar-8.png": 27600,
	"./avatar-pj.png": 12992
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47283;